import { useSelector } from 'react-redux';
import React, { Fragment, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'hooks/useTranslation';
import { useMetrics } from 'hooks/metrics/useMetrics';
import './style.scss';
import { QRLinkingErrorHeader } from '../QRLinkingErrorHeader';
import { OnboardingButton } from 'components/onboarding/components/DefaultButton';
import { getRegion } from 'utils/Region';
import { QR_LINKING_ERROR_KEYS } from '../translationKeys';

export const QRLinkingError = () => {
  const navigate = useNavigate();

  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(QR_LINKING_ERROR_KEYS),
    [translationMapper],
  );

  const { Alerta_Icono_Advertencia = '' } = useSelector(state => state.asset);

  return (
    <Fragment>
      <div className="QRLinkingError">
        <QRLinkingErrorHeader />

        <div className="QRLinkingError__Container">
          {Alerta_Icono_Advertencia ? (
            <img
              className="QRLinkingError__Container__AlertIcon"
              src={Alerta_Icono_Advertencia}
              alt="advertencia"
            />
          ) : (
            <span className="QRLinkingError__Container__AlertIcon" />
          )}

          <h2 className="QRLinkingError__Container__Title">
            {translatedTexts.TITLE}
          </h2>
          <p className="QRLinkingError__Container__P1">
            {translatedTexts.P1_PART_1}
            <br />
            {translatedTexts.P1_PART_2}
          </p>

          <OnboardingButton
            variant="secondary"
            size="large"
            onClick={() =>
              navigate(`/${getRegion()}/landing`, { replace: true })
            }
            className="QRLinkingError__Container__MainButton"
            textContent={translatedTexts.ACCEPT_BUTTON}
          />
        </div>
      </div>
    </Fragment>
  );
};
